<template>
  <!-- iOS Add to Home Screen Instructions Dialog -->
  <v-dialog
    v-model="showAddToHomeDialog"
    max-width="400">
    <v-card style="background: var(--v-cardColor-base); padding: 20px;">
      <v-card-title style="font-size: 18px; font-weight: bold;">
        Add to Home Screen
      </v-card-title>
      <v-card-text style="font-size: 14px; line-height: 1.6;">
        <p style="margin-bottom: 12px;">
          For the best fullscreen experience on iPad/iPhone:
        </p>
        <ol style="padding-left: 20px; margin-bottom: 12px;">
          <li style="margin-bottom: 8px;">Tap the <strong>Share</strong> button <v-icon size="small">mdi-export-variant</v-icon> in your browser</li>
          <li style="margin-bottom: 8px;">Scroll down and tap <strong>"Add to Home Screen"</strong></li>
          <li style="margin-bottom: 8px;">Tap <strong>"Add"</strong> in the top right corner</li>
          <li>Open CanvasPro from your home screen</li>
        </ol>
        <p style="opacity: 0.8; font-size: 13px;">
          This will launch CanvasPro as a fullscreen app without browser controls.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="showAddToHomeDialog = false">
          Got it
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog
    v-model="userConsentDialog"
    max-width="600">
    <TelemetryDialog
      v-if="userConsentDialog"
      v-on:close="userConsentDialog = false" />
  </v-dialog>
  <v-dialog
    width="410"
    v-model="account_drawer">
    <AccountDrawer v-on:close="account_drawer = false" />
  </v-dialog>
  <v-dialog
    v-model="open_help"
    width="800">
    <HelpModal
      :mdxName="route.name"
      @close="open_help = false" />
  </v-dialog>
  <v-dialog
    class="template-pop-up template-pop-up-fix"
    v-model="loggerDialogOpen">
    <LoggerDialog
      v-if="loggerDialogOpen"
      v-on:close="loggerDialogOpen = false" />
  </v-dialog>
  <v-dialog
    v-model="toggleFeedback"
    max-width="600">
    <GiveFeedBackDialog
      @close="toggleFeedback = false"
      v-if="toggleFeedback" />
  </v-dialog>
  <transition name="slide-fade">
    <div
      class="subtleshadow"
      v-if="state.uploading && !hide_upload"
      style="
        position: absolute;
        margin-bottom: 10px;
        margin-right: 15px;
        bottom: 30px;
        right: 0;
        width: 240px;
        height: 70px;
        z-index: 1;
        border-radius: 5px;
        display: flex;
        background: var(--v-cardColor-base);
        padding: 5px;
        align-items: center;
        display: flex;
        z-index: 100;
      ">
      <v-icon
        class="mr-1"
        size="x-large">
        mdi-progress-upload
      </v-icon>
      <v-btn
        icon
        size="x-small"
        variant="text"
        style="position: absolute; top: 2px; right: 2px; z-index: 10"
        title="Cancel upload"
        @click="handleCancelUpload">
        <v-icon size="small">mdi-close</v-icon>
      </v-btn>
      <div
        style="
          width: 100%;
          height: 100%;
          background: var(--darkerprimary-color);
          border-radius: 4px;
          overflow: hidden;
          z-index: 2;
        ">
        <div
          style="
            z-index: 3;
            width: 100%;
            height: 60px;
            color: white;
            position: absolute;
            display: flex;
            align-items: start;
            justify-content: center;
            flex-direction: column;
            overflow: hidden;
            white-space: nowrap;
            user-select: none;
            padding-left: 8px;
          ">
          <div style="opacity: 0.96; font-weight: bold; z-index: 999">
            Uploading ({{ state.upload_current_index }}/{{
              state.upload_total
            }})
          </div>
          <div
            style="
              opacity: 0.96;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 180px;
              display: flex;
              align-items: center;
              gap: 6px;
            ">
            <span style="overflow: hidden; text-overflow: ellipsis">{{
              state.upload_current_filename
            }}</span>
            <span
              v-if="state.upload_eta"
              style="opacity: 0.7; font-size: 0.85em; flex-shrink: 0"
              >{{ state.upload_eta }}</span
            >
          </div>
        </div>
        <div
          :style="
            state.upload_progress > 0
              ? `width: ${state.upload_progress}%;transition: all 0.3s;`
              : 'width:0%;transition: all 0s; '
          "
          style="
            display: flex;
            align-items: center;
            height: 60px;

            background: var(--primary-color);
          "></div>
      </div>
    </div>
  </transition>

  <div
    id="bottom-bar"
    v-if="deluge">
    <v-dialog
      max-width="600"
      v-model="player_health_dialog">
      <PlayerHealth
        v-on:close="player_health_dialog = false"
        v-if="player_health_dialog" />
    </v-dialog>
    <div
      v-if="deluge.info"
      class="CanvasProFont"
      style="
        color: white;
        opacity: 0.5;
        margin-left: 10px;
        display: flex;
        align-items: center;
        display: none;
      ">
      CanvasPro
      {{
        deluge.info.product_name.charAt(0).toUpperCase() +
        deluge.info.product_name.slice(1)
      }}
      v{{ deluge.info.version_number }}
    </div>
    <transition name="slide-fade">
      <div
        v-if="deluge.latest_log && deluge.latest_log.latest"
        style="
          margin-left: 10px;
          bottom: 6px;
          position: absolute;
          display: flex;
          align-items: center;
        ">
        <div
          @click="loggerDialogClick()"
          class="infochip infochip-hover"
          style="
            width: 50px !important;
            display: flex;
            justify-content: center;
            cursor: pointer;
            border-radius: 6px 0px 0px 6px;
          "
          :style="background">
          <v-icon>mdi-text-box-search-outline</v-icon>
        </div>
        <div
          class="infochip"
          style="border-radius: 0px 6px 6px 0px"
          :style="`background: ${deluge.latest_log.latest.bg}40; color: ${deluge.latest_log.latest.fg}87;`">
          {{ deluge.latest_log.latest.msg }}
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div
        v-if="state.notifications.length > 0"
        style="
          right: 10px;
          bottom: 70px; /* float above the bottom bar */
          position: fixed;
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          z-index: 2000;
          max-width: 360px;
        ">
        <div
          v-for="(note, i) in state.notifications"
          :key="i"
          class="infochip notification-popout"
          role="button"
          tabindex="0"
          @click="dismissNotification(i)"
          @keydown.enter.prevent="dismissNotification(i)"
          :style="
            note.type === 'error'
              ? `text-align: left !important; background: var(--v-error-base, #f25c5c); color: white; box-shadow: 0 2px 8px rgba(0,0,0,0.35); border-left: 6px solid var(--v-error-darker, #d04343); z-index:1000; max-width:360px; cursor: pointer;`
              : note.type === 'warning'
                ? `text-align: left !important; background: var(--v-warning-base, #f29a4e); color: white; box-shadow: 0 2px 6px rgba(0,0,0,0.25); border-left: 6px solid var(--v-warning-darker, #c9772a); z-index:1000; max-width:360px; cursor: pointer;`
                : `text-align: left !important; background: var(--v-primary-base, #5d6ae3); color: white; box-shadow: 0 2px 6px rgba(0,0,0,0.25); border-left: 6px solid var(--v-primary-darker, #4a54d1); z-index:1000; max-width:360px; cursor: pointer;`
          ">
          <v-icon class="mr-1">
            {{
              note.type === 'error'
                ? 'mdi-alert-circle'
                : note.type === 'warning'
                  ? 'mdi-alert'
                  : 'mdi-information'
            }}
          </v-icon>
          {{ note.msg }}
        </div>
      </div>
    </transition>
    <v-spacer />

    <div
      class="infochip"
      style="
        right: 10px;
        bottom: 6px;
        justify-content: center;
        display: flex;
        align-items: center;
        width: 400px;
        background: #1a1a1f40;
        position: absolute;
        font-size: 14px;
        padding: 0px;
        color: var(--bottombar-text);
        gap: 10px;
        background: transparent;
      ">
      <div
        v-if="state.telemetrySupport"
        style="
          cursor: pointer;
          display: flex;
          justify-self: center;
          align-items: center;
        "
        title="Provide Feedback">
        <div
          class="accicon"
          style="
            width: 32px;
            height: 32px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          @click="toggleFeedback = true">
          <v-icon
            title="Provide Feedback"
            size="x-large">
            mdi-comment-alert
          </v-icon>
        </div>
      </div>

      <div
        v-if="!isStandaloneMode"
        style="
          cursor: pointer;
          display: flex;
          justify-self: center;
          align-items: center;
        "
        title="Toggle Fullscreen">
        <div
          class="accicon"
          style="
            width: 32px;
            height: 32px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          @click="toggleFullScreen">
          <v-icon
            title="Toggle Fullscreen"
            size="40">
            mdi-fullscreen
          </v-icon>
        </div>
      </div>

      <div
        @click="router.push({ name: tab.route }).catch(() => {})"
        style="cursor: pointer"
        title="Change User Settings or Logout">
        <div
          class="accicon"
          style="
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          @click="open_help = true">
          <v-icon
            title="Show information for this page"
            size="x-large">
            mdi-information
          </v-icon>
        </div>
      </div>
      <div
        @click="router.push({ name: tab.route }).catch(() => {})"
        style="cursor: pointer"
        title="Change User Settings or Logout">
        <div
          class="accicon"
          style="
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
          @click="account_drawer = true">
          <v-icon size="x-large">mdi-account</v-icon>
        </div>
      </div>
      <div
        class="CanvasProFont HomeLogo"
        v-if="state.uploading"
        style="
          font-size: 17px;
          font-weight: bolder;
          color: white !important;
          padding-left: 6px;
          padding-right: 6px;
          border-radius: 6px;
          cursor: pointer;
        "
        @click="hide_upload = !hide_upload">
        <v-icon :color="hide_upload ? '' : 'primary'">
          mdi-progress-upload
        </v-icon>
      </div>
      <div
        v-if="state.telemetrySupport"
        style="
          cursor: pointer;
          display: flex;
          justify-self: center;
          align-items: center;
        "
        @click="userConsentDialog = !userConsentDialog"
        title="Telemetry">
        <div
          :style="`background: ${state?.current_user?.extra_info?.user_consent ? '#5d6ae3' : ''};`"
          class="accicon"
          style="
            width: 32px;
            height: 32px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
          <v-icon
            title="Telemetry Consent"
            size="x-large">
            mdi-shield-bug
          </v-icon>
        </div>
      </div>
      <div
        title="Hardware"
        style="
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-left: 6px;
        ">
        <div
          class="accicon"
          role="button"
          tabindex="0"
          aria-label="Show hardware"
          :aria-expanded="hardwareOpen"
          @click="toggleHardware"
          @keydown.enter.prevent="toggleHardware"
          @keydown.space.prevent="toggleHardware"
          ref="hardwareTrigger"
          style="
            border-radius: 6px;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
          ">
          <v-progress-circular
            :size="34"
            :width="4"
            :model-value="bottombarMax"
            :color="bottombarColor" />
        </div>
        <transition name="slide-up">
          <div
            v-if="hardwareOpen"
            class="hardware-popover"
            role="dialog"
            aria-modal="false"
            ref="hardwarePopover"
            tabindex="-1"
            style="position: fixed; right: 12px; bottom: 64px; z-index: 2000">
            <HardwareMiniDialog />
          </div>
        </transition>
      </div>
      <v-divider
        vertical
        color="white"
        inset />
      <div
        class="CanvasProFont"
        :title="serverTime.title.value"
        @click="serverTime.forceSync()"
        style="
          font-size: 21px;
          font-weight: bolder;
          color: var(--bottombar-text);
          padding-left: 6px;
          padding-right: 6px;
          border-radius: 6px;
          opacity: 0.85;
          font-variant-numeric: tabular-nums;
          user-select: none;
        ">
        {{ serverTime.displayTime }}
      </div>
    </div>
  </div>
</template>
<script setup>
import PlayerHealth from './PlayerHealth.vue';
import {
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
  nextTick,
  computed,
} from 'vue';
import { state } from '../../stores/deluge.js';
import { deluge } from '@/stores/deluge.js';
import AccountDrawer from '../Account/AccountDrawer.vue';
import { useRoute } from 'vue-router';
import HelpModal from '../Help-Hints/HelpModal.vue';
import Logger from './Logger.vue';
import LoggerDialog from './LoggerDialog.vue';
import serverTime from './../../serverTime';
import GiveFeedBackDialog from '../Telemetry/GiveFeedBackDialog.vue';
import TelemetryDialog from '../Telemetry/TelemetryDialog.vue';
import HardwareMiniDialog from './HardwareMiniDialog.vue';
const toggleFeedback = ref(false);
const route = useRoute();
const dialog = ref(false);
const open_help = ref(false);
const player_health_dialog = ref(false);
const hide_upload = ref(false);
const account_drawer = ref(false);
const loggerDialogOpen = ref(false);
const background = ref('');

function formatBytes(bytes) {
  if (!bytes || bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, i)).toFixed(i > 0 ? 1 : 0) + ' ' + units[i];
}
const userConsentDialog = ref(false);
// hardware mini popover state & refs
const hardwareOpen = ref(false);
const hardwareTrigger = ref(null);
const hardwarePopover = ref(null);

function toggleHardware() {
  hardwareOpen.value = !hardwareOpen.value;
  if (hardwareOpen.value) {
    nextTick(() => hardwarePopover.value?.focus());
    setTimeout(() => document.addEventListener('click', onDocumentClick), 0);
  } else {
    document.removeEventListener('click', onDocumentClick);
  }
}

const bottombarMax = computed(() => {
  function parsePercent(val) {
    if (val == null) return NaN;
    if (typeof val === 'number') return val;
    const s = String(val);
    const m = s.match(/-?\d+(?:\.\d+)?/);
    if (!m) return NaN;
    return parseFloat(m[0]);
  }

  const cpuN = parsePercent(deluge?.hw?.cpu?.usage);
  const ramN = parsePercent(
    deluge?.hw?.mem?.virtual_memory?.percent ?? deluge?.hw?.mem?.percent
  );
  let gpuUtilN = NaN;
  const gpu = deluge?.hw?.gpu;
  if (gpu) {
    const keys = [
      'Utilization GPU (%)',
      'usage',
      'utilization',
      'gpu_util',
      'utilization_gpu',
    ];
    for (const k of keys) {
      const v = parsePercent(gpu[k]);
      if (Number.isFinite(v) && v >= 0 && v <= 100) {
        gpuUtilN = v;
        break;
      }
    }
  }

  const a = Number.isFinite(cpuN) ? cpuN : -Infinity;
  const b = Number.isFinite(ramN) ? ramN : -Infinity;
  const c = Number.isFinite(gpuUtilN) ? gpuUtilN : -Infinity;
  const maxv = Math.max(a, b, c);
  if (!Number.isFinite(maxv) || maxv === -Infinity) return 0;
  return Math.min(100, Math.round(maxv));
});

const bottombarColor = computed(() => {
  const v = bottombarMax.value;
  if (v >= 85) return 'error';
  if (v >= 60) return 'warning';
  return 'primary';
});

const bottombarDriver = computed(() => {
  function parsePercent(val) {
    if (val == null) return NaN;
    if (typeof val === 'number') return val;
    const s = String(val);
    const m = s.match(/-?\d+(?:\.\d+)?/);
    if (!m) return NaN;
    return parseFloat(m[0]);
  }

  const cpu = parsePercent(deluge?.hw?.cpu?.usage);
  const ram = parsePercent(
    deluge?.hw?.mem?.virtual_memory?.percent ?? deluge?.hw?.mem?.percent
  );
  let gpuVal = NaN;
  let gpuKey = null;
  const gpu = deluge?.hw?.gpu;
  if (gpu) {
    const keys = ['Utilization GPU (%)', 'usage', 'mem_usage', 'temp_usage'];
    for (const k of keys) {
      const v = parsePercent(gpu[k]);
      if (Number.isFinite(v) && v >= 0 && v <= 100) {
        gpuVal = v;
        gpuKey = k;
        break;
      }
    }
  }

  const candidates = [
    { name: 'cpu', v: cpu },
    { name: 'ram', v: ram },
  ];
  if (Number.isFinite(gpuVal))
    candidates.push({ name: `gpu.${gpuKey || 'unknown'}`, v: gpuVal });
  let best = { name: null, v: -Infinity };
  for (const c of candidates) {
    if (Number.isFinite(c.v) && c.v > best.v) best = c;
  }
  return best.name || 'none';
});

function onDocumentKeyDown(e) {
  if (e.key === 'Escape' && hardwareOpen.value) {
    hardwareOpen.value = false;
  }
}

function onDocumentClick(e) {
  const target = e.target;
  if (!hardwareOpen.value) return;
  if (
    hardwarePopover.value &&
    hardwareTrigger.value &&
    !hardwarePopover.value.contains(target) &&
    !hardwareTrigger.value.contains(target)
  ) {
    hardwareOpen.value = false;
  }
}
function loggerDialogClick() {
  loggerDialogOpen.value = !loggerDialogOpen.value;
  localStorage.setItem('lastLogCheck', String(Date.now()));
  background.value = getBackground();
}

watch(
  () => deluge.latest_log,
  () => {
    background.value = getBackground();
  }
);

onMounted(() => {
  document.addEventListener('keydown', onDocumentKeyDown);
  // Check standalone mode for hiding fullscreen button
  isStandaloneMode.value = isStandalone();
});

onBeforeUnmount(() => {
  document.removeEventListener('keydown', onDocumentKeyDown);
  document.removeEventListener('click', onDocumentClick);
});

function getBackground() {
  const lastLogCheck = localStorage.getItem('lastLogCheck');
  if (
    deluge.latest_log.last_error > lastLogCheck ||
    (deluge.latest_log.last_error && !lastLogCheck)
  ) {
    return `background: #f25c5c40; color: #f25c5c87;`;
  } else if (
    deluge.latest_log.last_warning > lastLogCheck ||
    (deluge.latest_log.last_warning && !lastLogCheck)
  ) {
    return `background: #f29a4e40; color: #f29a4e87;`;
  }

  return `background: #1a1a1f40; color: #ffffff87;`;
}
// Detect iOS/iPadOS
const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
};

// Detect if running as standalone PWA
const isStandalone = () => {
  // Standard PWA detection
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  // Safari-specific standalone detection
  if (window.navigator.standalone === true) return true;
  // For iOS Chrome home screen shortcuts: check if launched without referrer
  // and window is close to full screen height (no significant browser chrome)
  if (isIOS() && !document.referrer) {
    const screenHeight = window.screen.height;
    const windowHeight = window.innerHeight;
    // If window height is within 100px of screen height, likely no browser chrome
    if (screenHeight - windowHeight < 100) return true;
  }
  return false;
};

// Dialog state for iOS add to home screen instructions
const showAddToHomeDialog = ref(false);

// Reactive ref for standalone mode (checked on mount)
const isStandaloneMode = ref(false);

const toggleFullScreen = () => {
  // If running as standalone PWA, we're already fullscreen
  if (isStandaloneMode.value) {
    // Already in fullscreen mode via PWA
    return;
  }

  // On iOS/iPadOS, the Fullscreen API doesn't work in browsers
  // Show instructions to add to home screen instead
  if (isIOS()) {
    showAddToHomeDialog.value = true;
    return;
  }

  // Standard fullscreen toggle for other platforms
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen().catch((err) => {
      console.warn('Fullscreen request failed:', err);
    });
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
  }
};

function dismissNotification(index) {
  // Defensive: ensure index is within bounds
  if (index == null) return;
  if (!Array.isArray(state.notifications)) return;
  if (index < 0 || index >= state.notifications.length) return;
  // Remove the specific notification
  state.notifications.splice(index, 1);
}

function handleCancelUpload() {
  // Call the cancelUpload function exposed by Upload.vue
  if (window.cancelUpload) {
    window.cancelUpload();
  }
}

window.addEventListener('beforeunload', (event) => {
  if (state.uploading) {
    event.preventDefault();
    event.returnValue = ''; // Required for Chrome to show the confirmation dialog
    return 'You are currently uploading a file. Leaving this page will cancel the upload.';
  }
});

// infochip-hover:hover go primary on hover, darken on click
</script>
<style>
.infochip-hover:hover {
  background: var(--v-primary-base) !important;
  color: white;
}
.rightchip:hover {
  color: white !important;
}
.infochip-hover:active {
  background: var(--v-primary-darker-base) !important;
  color: white;
}
.infochip {
  background: #1a1a1f;
  border-radius: 8px;
  align-items: center;
  font-size: 16px;
  padding: 6px 14px;
  color: white;
  width: 500px;
  max-width: 680px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 34px;
}
@media only screen and (max-width: 950px) {
  .infochip {
    max-width: 400px !important;
  }
}
@media only screen and (max-width: 700px) {
  .infochip {
    max-width: 400px !important;
  }
}

#bottom-bar {
  height: 40px;
  padding-top: 2px;
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: visible; /* allow notifications to poke out */
  z-index: 999999;
  /* Solid background to cover any iOS gap */
  background: var(--main-bg-color);
}

/* iOS: Extend bottom bar background below to cover any iOS reserved space */
#bottom-bar::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  transform: translateY(100%);
  background: var(--main-bg-color);
  z-index: -1;
  pointer-events: none;
}

/* In standalone PWA mode, use darker color for safe area */
@media all and (display-mode: standalone) {
  #bottom-bar::after {
    background: #0d0d0f !important; /* Darker safe area color */
    height: env(safe-area-inset-bottom, 20px) !important;
  }
}

/* Also target via body class (set by JavaScript) for reliability */
body.ios-standalone #bottom-bar::after {
  background: #0d0d0f !important;
  height: env(safe-area-inset-bottom, 20px) !important;
}

.notification-popout {
  transform-origin: bottom center; /* scale from bottom so bottom edge stays put */
  transition:
    transform 180ms ease,
    box-shadow 180ms ease;
  padding: 14px 14px; /* larger padding so notification extends upward */
  min-height: 56px; /* taller by default so it pokes above the bar */
  font-size: 15px;
  border-radius: 10px;
  display: flex;
  align-items: center;
}
.notification-popout:hover {
  transform: scaleY(1.06);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
}

.notification-text {
  color: white;
  margin-left: 50px; /* Move text to the left of the fullscreen button */
  opacity: 0.85;
  display: flex;
  align-items: center;
  transition: opacity 1s ease-out;
}

@media only screen and (max-width: 600px) {
  #bottom-bar {
    left: 0px;
    width: calc(100vw);
    position: fixed;
    z-index: 9999;
  }

  .user-icon {
    display: none;
  }
}

@keyframes marquee {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.accicon:hover {
  background: var(--primary-color);
  transition: all 0.15s ease-in;
  color: #ebecf0 !important;
}
/* hardware popover styles */
.hardware-popover {
  transform-origin: bottom right;
  background: var(--v-cardColor-base, #1a1a1f);
  min-width: 220px;
  padding: 8px;
  border-radius: 8px;
}
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 180ms ease-out;
}
</style>
